import { Box, Grid, Theme, useMediaQuery } from '@mui/material';

import { Skeleton } from '@mais-retorno-front/components/skeleton';

import { Container as ContentCard } from '../../components/customized-content-card/styles';
import { Container, ContentListCard } from '../../styles';

export const LoadingContentCards = () => {
  const isXsDown = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('lg')
  );

  const fakeContentList = [1, 2, 3, 4, 5];

  return (
    <Container>
      <ContentListCard>
        {fakeContentList?.map(() => (
          <ContentCard isXsDown={isXsDown} key={Math.random() * 10000}>
            <Grid
              container
              style={{
                width: '100%',
                padding: 16,
              }}
            >
              <Grid
                item
                component="figure"
                xs={12}
                sm={3}
                md={3}
                lg={3}
                style={{
                  padding: 0,
                  margin: 0,
                  borderRadius: '5px',
                  alignSelf: 'center',
                  textDecoration: 'none',
                }}
              >
                <Skeleton height="150px" width="100%" />
              </Grid>

              <Grid
                item
                component="div"
                xs={12}
                sm={9}
                md={9}
                lg={9}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  paddingLeft: isXsDown ? 0 : '15px',
                  textDecoration: 'none',
                  gap: 2,
                }}
              >
                <Skeleton height="30px" width="100%" />
                <Skeleton height="70px" width="100%" />
                <Box>
                  <Skeleton height="30px" width="120px" />
                </Box>
              </Grid>
            </Grid>
          </ContentCard>
        ))}
      </ContentListCard>
    </Container>
  );
};
